import { useNavigate, useParams, useSearchParams } from 'react-router';

export function useOfferEvaluationStepFromUrl(): [number, (newStep: number) => void] {
    const [params, setParams] = useSearchParams();
    const step = params.get('step');

    return [
        step ? parseInt(step, 10) || 0 : 0,
        (newStep: number) => setParams({ ...Object.fromEntries(params), step: newStep.toString() }),
    ];
}

export function useTenderIdFromUrl(): [string | undefined, (newTenderId: string) => void] {
    const params = useParams();
    const navigate = useNavigate();

    const tenderId = params.tenderId;
    return [tenderId, (newTenderId: string) => navigate(buildOfferEvaluationUrl(newTenderId), { replace: true })];
}

export function buildOfferEvaluationUrl(tenderId: string, step?: number) {
    return `/tender/offer-evaluations/${tenderId}${step ? `?step=${step}` : ''}`;
}
